// extracted by mini-css-extract-plugin
export default {"root":"IEEEFooter_root__4J96c","copyright":"IEEEFooter_copyright__yntX6","links":"IEEEFooter_links__LSmlB","link":"IEEEFooter_link__68W5b"};